import PropTypes from "prop-types";
import React from "react";
import CSSModules from "react-css-modules";
import { FormattedMessage } from "react-intl";
import styles from "./debitCardForm.scss";
const EXPIRATION_MONTH_LENGTH = 2;
const EXPIRATION_YEAR_LENGTH = 2;
const expirationMonthRegex = new RegExp(
  "^\\d{0," + EXPIRATION_MONTH_LENGTH + "}$"
);
const expirationYearRegex = new RegExp(
  "^\\d{0," + EXPIRATION_YEAR_LENGTH + "}$"
);

class ExpirationDateInput extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      expirationMonth: "",
      expirationYear: "",
      expirationError: false
    };
  }

  handleInputFocusYear(e) {
    const { target: elem, key } = e;
    const { selectionStart, previousSibling } = elem;
    if (
      selectionStart === 0 &&
      ["Backspace", "ArrowLeft"].indexOf(key) >= 0 &&
      previousSibling
    ) {
      setTimeout(() => previousSibling.focus());
    }
  }

  handleInputFocusMonth(e) {
    const { target: elem, key: eventKey, which } = e;
    let key = eventKey;
    if (
      (!eventKey || eventKey === "Unidentified") &&
      which >= 48 && which <= 57
    ) {
      key = which - 48;
    }
    const { selectionStart, nextSibling, value } = elem;
    const whenShouldItGoForward = /^1/.test(value) ? 2 : 1;
    if (
      selectionStart === whenShouldItGoForward &&
      /(\d)|(ArrowRight)/.test(key) &&
      nextSibling
    ) {
      nextSibling.focus();
    }
  }

  validateMonth = (value) => {
    const partial = value === "" || expirationMonthRegex.test(value) && Number(value) > 0 && Number(value) <= 12;
    const full = partial;
    return {partial, full};
  }

  validateYear = (value) => {
    const partial = value === "" || expirationYearRegex.test(value) && Number(value) > 0;
    const full = partial && value.length === EXPIRATION_YEAR_LENGTH;
    return {partial, full};
  }

  validate = (name, value) => {
    switch(name) {
      case 'expirationMonth':
        return this.validateMonth(value);
      case 'expirationYear':
        return this.validateYear(value);
    }
  }

  isExpired = (year, month) => {
    return new Date(
      2000 + Number(year),
      Number(month) // js Date() constructor expects month value starting at 0 (0 = Jan), still, we shouldn't adjust it because the card is valid during its expiration month.
    ).getTime() < new Date().getTime();
  }

  handleOnChangeEvent = e => {
    const { target: elem } = e;
    const { value, name } = elem;

    let {partial, full} = this.validate(name, value);

    if (partial) {
      this.setState(
        () => ({ [name]: value, expirationError: false }),
        () => {
          const {expirationMonth, expirationYear} = this.state;
          const expired = this.isExpired(expirationYear, expirationMonth);

          if (expired) {
            this.setState(() => ({ expirationError: expired }));
          }

          if (this.props.onChange) {
            const expirationDate = {expirationMonth, expirationYear};
            this.props.onChange((!full || expired) ? null : expirationDate, this.props.name);
          }
        });
      }
  };

  render() {
    return (
      <div styleName="inputGroupColumn">
        <label>
          <FormattedMessage id="updateDebitCard.form.expirationDate" />
        </label>
        <div data-at="expirationDateInput" styleName="expirationDate">
          <input
            name="expirationMonth"
            type="text"
            pattern="[0-9]*"
            placeholder="mm"
            value={this.state.expirationMonth}
            onChange={this.handleOnChangeEvent}
            onKeyUp={this.handleInputFocusMonth}
            onKeyPress={this.handleKeyPressMonth}
            data-at="creditCardExpMonth"
            />
          <input
            name="expirationYear"
            type="text"
            value={this.state.expirationYear}
            pattern="[0-9]*"
            placeholder="yy"
            onChange={this.handleOnChangeEvent}
            onKeyDown={this.handleInputFocusYear}
            onKeyPress={this.handleKeyPressYear}
            data-at="creditCardExpYear"
          />
        </div>
        {this.state.expirationError && (
          <span styleName="inputError">
            <FormattedMessage id="updateDebitCard.form.error.expired" />
          </span>
        )}
      </div>
    );
  }
}

export default CSSModules(styles, { allowMultiple: true })(ExpirationDateInput);



// WEBPACK FOOTER //
// ./src/components/common/debitCardForm/ExpirationDateInput.js